export enum TemplateImportTypeEnum {
  FullVersion = 1,
  SimpleVersion = 2
}

